module.exports = __webpack_public_path__ + "static/media/lightning_logo.0af4dd7f.jpeg";